import { useEffect, useState } from 'react';
import { OnboardingCommanderLogo, onBoardingsvg } from '@/assets/icons/AuthIcon';

// Get the prospecting URL based on environment
const getProspectingUrl = (path: string) => {
  if (import.meta.env.PROD) {
    return `/prospecting${path}`;
  }
  const baseUrl = import.meta.env.VITE_PROSPECTING_URL || 'http://localhost:3002';
  return `${baseUrl}/prospecting${path}`;
};

// Redirect to heatmap tour page
const redirectToTour = () => {
  window.location.href = getProspectingUrl('/heatmap/dashboard?tour=true');
};

export default function OnboardingCompletion() {
  const [showContinueButton, setShowContinueButton] = useState(false);

  useEffect(() => {
    // Show manual continue button after 1.5 seconds as fallback
    const buttonTimer = setTimeout(() => setShowContinueButton(true), 1500);

    // Auto-redirect after 2.5 seconds (reduced from 4s)
    const redirectTimer = setTimeout(() => {
      redirectToTour();
    }, 2500);

    return () => {
      clearTimeout(buttonTimer);
      clearTimeout(redirectTimer);
    };
  }, []);
  return (
    <div>
      <div className="absolute inset-0 w-full h-full z-9 bg-[#112125]">
        <div className="w-full h-full">{onBoardingsvg}</div>
      </div>
      <div className="relative flex items-center justify-center px-4 h-[calc(100vh-200px)]">
        <div className="flex-1 max-w-6xl w-full bg-white max-h-[742px] h-full rounded-xl">
          <div className="max-w-md mx-auto text-center py-20 h-full flex flex-col gap-[30px] lg:gap-[69px] justify-center">
            <div className="mb-4 flex items-center justify-center mx-auto">
              <OnboardingCommanderLogo />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">Onboarding Complete</h2>
              <p className="text-gray-600 mb-4">
                You've completed the onboarding process. Welcome to Commander!
              </p>
              <p className="text-gray-500 text-sm mb-4">Redirecting you to the product tour...</p>
              {showContinueButton && (
                <button
                  type="button"
                  onClick={redirectToTour}
                  className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition-colors"
                >
                  Continue to Tour
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
